
<template>
    <el-dialog :title="textMap[title]" :visible.sync="dialogFormVisible">
        <avue-form ref="form" v-model="obj" :rules="rules" :option="option">
            <template slot-scope="scope" slot="menuForm">
                <el-button  @click="handleEmpty">取 消</el-button>
                <el-button type="primary" @click="change_pwd">确 定</el-button>
            </template>
        </avue-form>
    </el-dialog>
</template>
<script>
 import {getObj,addObj,putObj} from '@/api/admin/role'
import {fetchTree} from '@/api/admin/dept'
import {formatSelectTree,dealElement} from '@/util/util'
import waves from '@/directive/waves/index.js' // 水波纹指令
import {objKeySort} from '@/util/ajaxsign'
import {phone,email,validatePass,validatePass2} from "@/util/Format"
export default {
    name: 'table_user',
    directives: {
        waves
    },
    data() {
        return {
            title : '',
            textMap: {
                update: '编辑角色',
                create: '创建角色'
            },
            userId : '',
            dialogFormVisible : false,
            obj : {},
            rules : {},
            option:{
                emptyBtn:false,
                submitBtn:false,
                submitText : '确定',
                column: [ {
                    label: "角色名称",
                    prop: "roleName",
                    disabled : false,
                    span:12,
                    rules : [ 
                        {required: true, message: '请输入角色名称', trigger: 'blur' },
                        {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
                    ]
                },{
                    label: "角色标识",
                    prop: "roleCode",
                    span:12,
                    rules : [
                        {required: true, message: '请输入角色名标识', trigger: 'blur' },
                        {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
                    ] 
                },{
                    label: "角色描述",
                    prop: "roleDesc",
                    span:12,
                    rules : [
                        {required: true, message: '请输入角色描述', trigger: 'blur' },
                        {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
                    ]
                },{
                    label: "所属部门",
                    prop: "roleDeptId",
                    type: "tree",
                    span:12,
                    dicUrl : '/dept/tree',
                    dicMethod:"post",
                    dicQuery : objKeySort({}),
                    props : {
                        label: 'name',
                        value: 'id'
                    }
                }]
            }
        }
    },
    created() {},
    methods: {
        //展示弹出层
        dialog(data,roleId){
            this.title = data;
            this.dialogFormVisible = true;
        },

        //修改数据展示
        getobj(data){
            getObj(objKeySort({id:data})).then(response => {
                delete response.data.data.delFlag;
                delete response.data.data.createTime;
                this.obj = response.data.data;
                console.log(this.obj)
            })
        },

        handleEmpty(){
            this.dialogFormVisible = false;
            this.$refs.form.resetForm();
        },

        //处理数据
        change_pwd(){
            if(this.title == "create"){
                this.addObj()
            }else{
                this.update()
            }
        },

        //新增数据操作
        addObj(){
            this.$refs.form.validate(vaild=>{
                if(vaild){
                     addObj(objKeySort(this.obj)).then(res => {
                        this.$message({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        })
                        this.handleEmpty();
                        this.$emit('refresh','');
                    })
                }
            })
        },

        //修改数据
        update(){
            this.$refs.form.validate(vaild=>{
                if(vaild){
                    putObj(objKeySort(dealElement(this.obj))).then(() => {
                        this.dialogFormVisible = false
                        this.handleEmpty();
                        this.$emit('refresh','');
                        this.$message({
                            title: '成功',
                            message: '修改成功',
                            type: 'success',
                            duration: 2000
                        })
                    })
                }
            })
            
        }
    }
}
</script>